import { useAppDispatch } from 'src/hooks';

// Components
import TherapyAdditionalInfo from 'src/components/cards/admin/therapy/AdditionlInfo';

// Interfaces
import { TherapyProfilePictureFormProps } from 'src/interfaces/therapyInterface';

// Redux
// import { setTherapistDetailView } from 'src/redux/slices/therapy.slice';

// Services
import { uploadTherapyPictureUseCase } from 'src/services/therapy/useCases';

const AddTherapyAdditionalInfo = () => {
  const dispatch = useAppDispatch();
  const currentTherapistId = JSON.parse(localStorage.getItem('current-Therapist') || '');
  const handleSuccess = async (values: TherapyProfilePictureFormProps) => {
    const formData = new FormData();
    formData.append('profilePicture', values.profilePicture as Blob);
    if (values.profilePicture) {
      dispatch(
        uploadTherapyPictureUseCase({ therapistId: currentTherapistId, profilePicture: formData }),
      );
    }
  };

  return <TherapyAdditionalInfo onSuccess={handleSuccess} isEditing={false} />;
};

export default AddTherapyAdditionalInfo;
